var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.03 68.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.4,15.58,0,24V14.74L29.19,0V68.78H17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.63,57.83l9.55-5.34h2.67c.28,3.79,4.91,6.74,10.8,6.74H71.3l9.13-4.49V36.07l-13.2,6.18h-2.8c-13.06,0-19.8-7.3-19.8-21.62V11.09L64,1.4h.71C83.94,1.4,92.22,9.12,92.22,27V57.27l-23,11.51H66.11C56.57,68.78,47.86,64.42,44.63,57.83ZM80.43,33V28.35c0-13.47-3.79-17.4-16.85-17.4H56.42v7.44C56.42,29.9,59.51,33,71,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.85,58.81h31.3V51.93c0-10-3.37-13-14.18-13h-6.45V34.53l18.81-9V24.7c0-10.52-2.81-13.75-12.22-13.75h-5.47V21.47l-11.79,5.9V11.23L124.5,1.4h.84C138.68,1.4,146,8.7,146,22v5.05l-15.43,6.74c11.65,0,17.4,5.33,17.4,16.14v8.56L128,68.78H104.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.38,43V11.23L183,1.4h4.49C206.61,1.4,215,9.26,215,27.23V59l-19.65,9.83h-4.49C171.8,68.78,163.38,60.92,163.38,43Zm39.3,16.28V28.35c0-13.47-3.65-17.4-16.42-17.4H175.73V41.83c0,13.47,3.65,17.4,16.56,17.4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.3db87813de5db32d28d14d5047102782.svg";
export { ForwardRef as ReactComponent };